import { App } from 'vue';
import { install as VueReCaptcha } from 'vue3-recaptcha-v2';

export default function install(app: App<Element>) {
  const branch: env.vue_app = {
    local: '6LcYkgwqAAAAALvUTO32SeOYGvhiDC5sdNsWy0t_',
    development: '6LcYkgwqAAAAALvUTO32SeOYGvhiDC5sdNsWy0t_',
    release: '6Lc-kgwqAAAAANhzXzChJbh1Pk9FNW8WgXkaOUis',
    master: '6LcWkwwqAAAAAAE-sCgoO8h9TR42uXeTIP6Wygmk',
  };

  app.use(VueReCaptcha, {
    sitekey: branch[import.meta.env.VITE_ENV] || '',
  });
}
